export const moduleConfig = {
    appName: 'Przewozy Autokarowe Patryk Sołtysiak',
    isAdminEnabled: false,
    isBlogEnabled: false,
    blogHasCategory: false,
    blogHasReview: false,
    isContactEnabled: true,
    isSettingsEnabled: false,
    isDeleteUserOptionEnabled: false,
    isNewsletterEnabled: false,
    isReservationEnabled: false,
    isProductEnabled: false,
};
